import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../core/_infrastructure/classes/services/global.service';
import { HttpParams } from '@angular/common/http';
import { EspeciesGruposFormasService } from '../../_mantenimiento/especies/especiesgruposformas/especiesgruposformas.service';
import { NotificationService } from '../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';
import {
    Tc,
    WBotanicaExtendedItemResultsViewModel,
    WBotanicaExtendedViewModel,
    EnumSiNoTodos,
    TcPerfilUsuarioEnum,
} from '../../core/_infrastructure/types/common';
import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';
import { FilterSearchingWBotanicaExtendedViewModel } from '../../_mantenimiento/especies/especiesgruposformas/especiesgruposformas.types';

@Component({
    selector: 'app-buscadorespecies-list',
    templateUrl: './buscadorespecies-list.component.html',
})
export class BuscadorEspeciesListComponent extends ComponentBase implements OnInit {
    @Input() dialogMode = false;
    @Output() selected = new EventEmitter<any>();

    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    IdCodigoEppo: number | null = null;
    resultEspeciesGruposFormas: WBotanicaExtendedItemResultsViewModel;
    cols: any[];

    listGrupo: Tc[];
    listForma: Tc[];
    listSubForma: Tc[];

    visibilitySpinner = false;

    isCollapsed = false;
    title = 'Buscador Especies';

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private especiesGruposFormasService: EspeciesGruposFormasService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.resultEspeciesGruposFormas = new WBotanicaExtendedItemResultsViewModel();
    }

    ngOnInit() {
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdNombreCientificoDescripcion', header: 'Nombre Científico' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'Activo', header: 'Activa' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'IdGrupoDescripcion', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'IdSubFormaDescripcion', header: 'Subforma' },
            { field: 'HabilitadoImportacion', header: 'Habilitada Importación' },
            { field: 'HabilitadoExportacion', header: 'Habilitada Exportación' },
            { field: 'HabilitadoChina', header: 'Habilitada China' },
        ];

        //Todo: agaro. 27012021. Diferenciamos si es solicitante o no, para establecer filtros y no mostrarlos a petición en la incidencia 69461
        if (!this.isSolicitante) {
            //Como hasta ahora.
            this.form = this.fb.group({
                IdGrupo: null,
                IdForma: null,
                IdSubForma: null,
                CodigoEppo: '',
                IdNombreCientificoDescripcion: '',
                NombreComun: '',
                Activo: EnumSiNoTodos.TODOS,
                HabilitadoImportacion: EnumSiNoTodos.TODOS,
                HabilitadoExportacion: EnumSiNoTodos.TODOS,
                HabilitadoChina: EnumSiNoTodos.TODOS,
            });
        } else {
            this.form = this.fb.group({
                IdGrupo: null,
                IdForma: null,
                IdSubForma: null,
                CodigoEppo: '',
                IdNombreCientificoDescripcion: '',
                NombreComun: '',
                Activo: EnumSiNoTodos.SI,
                HabilitadoImportacion: EnumSiNoTodos.SI,
                HabilitadoExportacion: EnumSiNoTodos.TODOS,
                HabilitadoChina: EnumSiNoTodos.TODOS,
            });
        }

        this.isCollapsed = false;

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        let hayFiltros = false;

        if (this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo != null) {
            this.form.patchValue({
                IdGrupo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo,
            });

            this.onSelectGrupo();

            this.form.patchValue({
                IdForma: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdForma,
            });

            this.onSelectForma();

            this.form.patchValue({
                IdSubForma: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdSubForma,
            });

            hayFiltros = true;
        }

        if (
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun != '' ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion != EnumSiNoTodos.TODOS ||
            this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                CodigoEppo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo,
                IdNombreCientificoDescripcion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion,
                NombreComun: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun,
                Activo: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo,
                HabilitadoImportacion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion,
                HabilitadoExportacion: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion,
                HabilitadoChina: this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina,
            });

            hayFiltros = true;
        }

        if (hayFiltros) this.onSearchButton();
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdGrupo = this.form.value.IdGrupo;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdForma = this.form.value.IdForma;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdSubForma = this.form.value.IdSubForma;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.CodigoEppo = this.form.value.CodigoEppo;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.IdNombreCientificoDescripcion = this.form.value.IdNombreCientificoDescripcion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.NombreComun = this.form.value.NombreComun;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.Activo = this.form.value.Activo;

        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoImportacion = this.form.value.HabilitadoImportacion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoExportacion = this.form.value.HabilitadoExportacion;
        this.especiesGruposFormasService.currentFilterEspeciesGruposFormas.HabilitadoChina = this.form.value.HabilitadoChina;

        this.searchingButton = true;
        this.isCollapsed = true;

        // Remove possile selection for the parent component
        this.setSelection(null, false);
    }

    Search(pageNumber: number, asc = 0, orderBy = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('idGrupo', this.form.value.IdGrupo);
        params = params.append('idForma', this.form.value.IdForma);
        params = params.append('idSubForma', this.form.value.IdSubForma);
        params = params.append('codigoEppo', this.form.value.CodigoEppo);
        params = params.append('idNombreCientificoDescripcion', this.form.value.IdNombreCientificoDescripcion);
        params = params.append('nombreComun', this.form.value.NombreComun);
        params = params.append('activo', this.form.value.Activo);
        params = params.append('habilitadoImportacion', this.form.value.HabilitadoImportacion);
        params = params.append('habilitadoExportacion', this.form.value.HabilitadoExportacion);
        params = params.append('habilitadoChina', this.form.value.HabilitadoChina);

        this.loading = true;
        this.especiesGruposFormasService.getEspeciesGruposFormasPagedByFilter(params).subscribe(result => {
            this.resultEspeciesGruposFormas = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            CodigoEppo: '',
            IdNombreCientificoDescripcion: '',
            NombreComun: '',
            Activo: EnumSiNoTodos.TODOS,
            HabilitadoImportacion: EnumSiNoTodos.TODOS,
            HabilitadoExportacion: EnumSiNoTodos.TODOS,
            HabilitadoChina: EnumSiNoTodos.TODOS,
        });
        this.searchingButton = false;
        this.isCollapsed = false;

        this.listForma = [];
        this.listSubForma = [];

        this.resultEspeciesGruposFormas = new WBotanicaExtendedItemResultsViewModel();

        // Remove possile selection for the parent component
        this.setSelection(null, false);
    }

    onSelectGrupo() {
        const idGrupo = this.form.value.IdGrupo;

        //limpiar listas que alimentan los combos dependientes
        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });
        this.listSubForma = [];

        this.form.patchValue({
            IdForma: null,
            IdSubForma: null,
        });
    }

    onSelectForma() {
        const idForma = this.form.value.IdForma;

        this.globalService.getSubFormasByForma(idForma).subscribe(res => {
            this.listSubForma = res;
        });

        this.form.patchValue({
            IdSubForma: null,
        });
    }

    onDetail(item: WBotanicaExtendedViewModel) {
        this.router.navigate(['/global/buscadorEspecies/detail', item.Id]);
    }

    CreateModel() {
        let model: FilterSearchingWBotanicaExtendedViewModel = new FilterSearchingWBotanicaExtendedViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.especiesGruposFormasService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }

    /**
     * This event is used only when in dialogMode.
     * It will have to tell which kind of selection the user has made.
     * The data selected will be raised alongside the type of selection.
     * @param $event
     * @param rowData WBotanicaExtendedViewModel
     */
    onSelect($event: any, rowData: any): void {
        $event.stopPropagation();
        this.setSelection(rowData, false);
    }

    /**
     * This event is used only when in dialogMode.
     * It will have to tell which kind of selection the user has made.
     * The data selected will be raised alongside the type of selection.
     * @param $event
     * @param rowData WBotanicaExtendedViewModel
     */
    onRowDblClick($event: any, rowData: any): void {
        $event.stopPropagation();
        this.setSelection(rowData, true);
    }

    private setSelection(rowData: any, dblclick: boolean): void {
        if (this.dialogMode) {
            this.selected.emit({ selection: rowData, dblclick: dblclick });
        }
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultEspeciesGruposFormas?.ResultList ? this.resultEspeciesGruposFormas?.ResultList?.length > 0 : false;
    }
}
